export const PDP_MVP_ABC_VARIANT_1 = '63326:2';
export const PDP_MVP_ABC_VARIANT_2 = '63326:3';
